import script from "./DynamicIframe.vue?vue&type=script&lang=ts&setup=true"
export * from "./DynamicIframe.vue?vue&type=script&lang=ts&setup=true"

import "./DynamicIframe.vue?vue&type=style&index=0&id=0259213c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0259213c"]])

export default __exports__